"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CarWithTelematics.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CarWithTelematics = function CarWithTelematics(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 219.62 245.33"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Car with telematics"), _react2.default.createElement("g", {
    className: "car-with-telematics",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "chasis",
    d: "M198.41 141.84l21.21-12.61-5.16-7.41L193 134.61l-22.81-54H49.47l-22.81 54-21.5-12.79L0 129.23l21.21 12.61c-8.64 3.64-14.66 11.69-14.66 21v30.96c0 11.27 8.79 20.68 20.37 22.68v7.69c0 11.67 10.27 21.17 22.9 21.17s22.9-9.5 22.9-21.17v-7.29h74.21v7.29c0 11.67 10.27 21.17 22.9 21.17s22.9-9.5 22.9-21.17v-7.68a24.87 24.87 0 0 0 17.5-11.93 21.78 21.78 0 0 0 2.87-10.76v-30.94c-.02-9.33-6.05-17.39-14.69-21.02zM56 89.43h49v17h9.53v-17h49.07l21.27 50.34H34.71zm7.2 134.73c0 6.82-6 12.36-13.36 12.36s-13.4-5.52-13.4-12.36v-7.29h26.73v7.29zm106.64 12.36c-7.37 0-13.36-5.54-13.36-12.36v-7.29h26.73v7.29c-.03 6.84-6.03 12.36-13.4 12.36zm33.73-42.73a13.25 13.25 0 0 1-1.77 6.64 15.63 15.63 0 0 1-13.67 7.63H31.51c-8.51 0-15.44-6.4-15.44-14.27v-30.93c0-7.87 6.93-14.27 15.44-14.27h156.6c8.51 0 15.43 6.4 15.43 14.27v30.94z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "headlamps",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M173.51 162.57c-10.59 0-19.2 8-19.2 17.75 0 7.14 4.6 13.56 11.72 16.35a20.51 20.51 0 0 0 7.47 1.39 19.56 19.56 0 0 0 16.73-9 16.7 16.7 0 0 0 2.47-8.71c.01-9.82-8.6-17.78-19.19-17.78zm8.43 22.13c-2.36 3.87-7.87 5.54-12.19 3.86a8.94 8.94 0 0 1-5.9-8.24c0-4.93 4.34-8.94 9.66-8.94s9.67 4 9.67 8.94a8.38 8.38 0 0 1-1.24 4.38z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    "data-name": "headlamp",
    d: "M46.11 162.57c-10.59 0-19.2 8-19.2 17.75s8.61 17.74 19.2 17.74 19.2-8 19.2-17.74-8.62-17.75-19.2-17.75zm0 26.68c-5.33 0-9.67-4-9.67-8.93s4.34-8.94 9.67-8.94 9.67 4 9.67 8.94-4.34 8.93-9.67 8.93z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: undefined
  })), _react2.default.createElement("path", {
    d: "M92.4 175.91h34.81v8.81H92.4v-8.81z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: undefined
  }), _react2.default.createElement("g", {
    className: "telematic-lines",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M150.6 63.4c-.8 0-1.6-.3-2.2-.9-10.3-10.4-24-16.1-38.6-16.1h-.1c-14.5 0-28.2 5.6-38.4 15.9-1.2 1.2-3.2 1.2-4.5 0-1.2-1.2-1.2-3.2 0-4.5 11.5-11.4 26.7-17.7 42.9-17.7h.2c16.2 0 31.5 6.4 43 17.9 1.2 1.2 1.2 3.3 0 4.5-.7.6-1.5.9-2.3.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M165.2 49.3c-.8 0-1.5-.3-2.1-.9-29.4-29.5-77.2-29.6-106.7-.3-1.1 1.1-3 1.1-4.1 0-1.1-1.1-1.1-3 0-4.1 31.7-31.6 83.3-31.5 114.8.3l.1.1c1.1 1.1 1.1 3 0 4.1-.6.6-1.3.8-2 .8z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M178.2 34.4c-.7 0-1.4-.3-2-.8l-.1-.1c-17.7-17.8-41.3-27.6-66.3-27.6h-.2c-25 0-48.5 9.7-66.2 27.4-1.1 1.1-3 1.1-4.1 0-1.1-1.1-1.1-3 0-4.1C58.1 10.3 83.1 0 109.6 0h.2c26.6.1 51.6 10.5 70.4 29.4 1.1 1.1 1.2 3 .1 4.1-.6.6-1.3.9-2.1.9z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: undefined
  }))));
};
exports.default = CarWithTelematics;